import { ProductName } from '@pypestream/api-services';
import { SmartContext } from '../xstate/smart.xstate-utils';
import { generateBaseURLsToTools } from './generate-base-urls/generate-base-urls';

export const handleGoHome = ({
  accountId,
  redirectedDueToNoToolAccess = false,
  app,
}: {
  accountId: SmartContext['accountId'];
  redirectedDueToNoToolAccess?: boolean;
  app?: ProductName;
}) => {
  const url = new URL(
    `${generateBaseURLsToTools(window.location).Manager}${accountId ? `/organization/${accountId}` : ''}`
  );

  if (redirectedDueToNoToolAccess && app) {
    url.searchParams.set('redirectedDueToNoToolAccess', 'true');
    url.searchParams.set('app', app);
  }

  window.location.href = url.href;
};
